<template>
  <div>
    <div class="thankyou-page" v-if="invoice">
      <div class="container">
        <h1 class="text-center">ขอบคุณสำหรับการบริจาค</h1>
        <h2 class="text-center">ที่ร่วมสร้างโอกาสทางการศึกษาให้กับน้อง ๆ</h2>

        <div v-if="promoteLinks" class="promo-links">
            <div v-for="link in promoteLinks" class="promo-link-item d-flex justify-content-center" :class="`promo-link-item-type-${link.type}`">
              <template v-if="link.type === 'link'">
                <a
                  :href="link.content.url"
                  :class="link.content.class"
                  :target="link.content.target || '_self'"
                  class="btn btn--default btn--white"
                >
                    <div>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.1212 6H17.0001C17.0001 3.23858 14.7615 1 12.0001 1C9.23865 1 7.00008 3.23858 7.00008 6H4.87898C3.82286 6 2.94876 6.82118 2.88288 7.87525L2.13288 19.8752C2.06092 21.0266 2.97534 22 4.12898 22H19.8712C21.0248 22 21.9392 21.0266 21.8673 19.8752L21.1173 7.87524C21.0514 6.82117 20.1773 6 19.1212 6ZM7.00008 8H4.87898L4.12898 20L19.8712 20L19.1212 8H17.0001V11C17.0001 11.5523 16.5524 12 16.0001 12C15.4478 12 15.0001 11.5523 15.0001 11V8H9.00008V11C9.00008 11.5523 8.55236 12 8.00008 12C7.44779 12 7.00008 11.5523 7.00008 11V8ZM12.0001 3C13.6569 3 15.0001 4.34315 15.0001 6H9.00008C9.00008 4.34315 10.3432 3 12.0001 3Z" fill="#F6931D"/>
                      </svg>
                      {{ link.content.text }}
                    </div>
                </a>
              </template>
              <template v-if="link.type === 'linked-image'">
                <a
                  :href="link.content.link.url"
                  :class="link.content.link.class"
                  :target="link.content.link.target || '_self'">
                  <img :src="link.content.image.src" :alt="link.content.image.alt" />
                </a>
              </template>
            </div>
        </div>

        <div class="flex-center block-social-share">
          <span>แชร์การบริจาคของคุณ</span>
          <vue-goodshare-facebook
                  :page_url="$config.MAIN_WEBSITE_URL"
                  title_social="Facebook"
                  has_icon />
          <share-line-button
                  :page_url="$config.MAIN_WEBSITE_URL"
                  title_social="Line"
                  has_icon />
          <!-- <a href=""><img class="img-responsive" src="../../../assets/img/btn-fb-share.png" alt="Facebook Share" /></a>
          <a href=""><img class="img-responsive" src="../../../assets/img/btn-line-share.png" alt="Line Share" /></a> -->
        </div>
        <div v-if="showUploadSlipForm">
          <div class="text-center thankyou-remark">
            <p>อีกสักครู่ คุณจะได้รับอีเมลยืนยันการบริจาคจากทางเรา หากบริจาคด้วยวิธีการโอนเงิน กรุณายืนยันการโอนเงิน จากแบบฟอร์มด้านล่าง หรือจากลิงก์แบบฟอร์มแจ้งโอนเงินในอีเมลที่ระบบส่งให้</p>
          </div>
          <div class="thankyou-banner text-center hide-md">
            <img src="../../../assets/img/kids-thankyou@2x.png" width="900px" class="img-responsive" alt="ขอบคุณ" />
          </div>
          <div class="thankyou-banner text-center show-md">
            <img src="../../../assets/img/kids-thankyou-mobile.png" class="img-responsive" alt="ขอบคุณ" />
          </div>
        </div>

        <div v-if="!showUploadSlipForm">
          <div class="text-center thankyou-remark">
            <p>อีกสักครู่ คุณจะได้รับอีเมลยืนยันการบริจาคจากทางเรา</p>
          </div>
          <div class="thankyou-banner text-center hide-md">
            <img src="../../../assets/img/kids-thankyou@2x.png" width="900px" class="img-responsive" alt="ขอบคุณ" />
          </div>
          <div class="thankyou-banner text-center show-md">
            <img src="../../../assets/img/kids-thankyou-mobile.png" class="img-responsive" alt="ขอบคุณ" />
          </div>
          <!--<div class="block text-center mt-30"><a :href="backUrl" class="btn btn&#45;&#45;white btn-md">กลับไปหน้าแรก</a></div>-->
        </div>

      </div> <!--  -->
    </div> <!-- /thankyou-page -->

    <!-- note - เช็คสั่งจ่าย -->
    <div class="show-note" v-if="showChequeInfo">
      <div class="">
        <div class="container">
          <div class="block-primary block shadow radius mb-15 mt-15">
            <h2 class="text-center mb-20">การบริจาคผ่านเช็คสั่งจ่าย</h2>
            <div class="form__item pd-15">
              <div class="show-note-item">
                <strong>1. เช็คสั่งจ่าย</strong>
                <div class="indent">มูลนิธิยุวพัฒน์ เพื่อโครงการร้อยพลังการศึกษา</div>
              </div>
              <div class="show-note-item">
                <strong>2. จัดส่งเช็คตัวจริงมาตามที่อยู่ด้านล่างนี้</strong>
                <div class="indent">
                ฝ่ายบัญชี<br />
                มูลนิธิยุวพัฒน์<br />
                1 อาคารพรีเมียร์คอร์เปอเรทปาร์ค ถนนศรีนครินทร์ แขวงหนองบอน เขตประเวศ กรุงเทพ 10250
              </div>
              </div>
            </div>
            <p class="mw-600">เมื่อเจ้าหน้าที่ตรวจสอบความถูกต้องแล้ว ผู้บริจาคจะได้รับอีเมลยืนยันอีกครั้ง จึงจะถือว่าการบริจาค
เสร็จสมบูรณ์</p>
          </div>
        </div>
      </div>
    </div>


    <div class="show-uploadslip" v-if="showUploadSlipForm">
      <upload-slip />
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import UploadSlip from '@/components/UploadSlip'
  import VueGoodshareFacebook from 'vue-goodshare/src/providers/Facebook'
  import Parser from '@/parser'
  import ShareLineButton from '../../ShareLineButton'

  export default {
    name: 'ThankYouBase',

    components: {
      UploadSlip,
      VueGoodshareFacebook,
      ShareLineButton
    },

    props: {
      invoice: {
        type: Object,
        default: null
      },
      fullProduct: {
        type: Object,
        default: null
      },
    },

    computed: {
      showUploadSlipForm () {
        return this.invoice && this.invoice.payment_method === 'bank_transfer'
      },
      showChequeInfo () {
        return this.invoice && this.invoice.payment_method === 'cheque'
      },
      backUrl () {
        return Vue.config.MAIN_WEBSITE_URL
      },

      promoteLinks () {
        if (this.fullProduct && this.fullProduct.meta && this.fullProduct.meta.thankyou_promote_link) {
          return Parser.link.parseAll(this.fullProduct.meta.thankyou_promote_link)
        }
        return null
      }
    }
  }
</script>

<style scoped lang="scss">
  .promo-links {
    .promo-link-item-type-link {
      a > div {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
      }
    }
  }
  .thankyou-page {
    background: rgb(252,186,62); /* Old browsers */
    background: -moz-linear-gradient(top, rgba(252,186,62,1) 0%, rgba(243,137,0,1) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, rgba(252,186,62,1) 0%,rgba(243,137,0,1) 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, rgba(252,186,62,1) 0%,rgba(243,137,0,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    color: #fff;
    font-size: 17px;
    position: relative;
    padding: 2rem 0;
    &:before {
      content: "";
      background: url("../../../assets/img/bg-hex_icon-trans.png") no-repeat center center;
      background-size: 100%;
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      pointer-events: none;
    }
    .btn {
      user-select: none;
    }
    p {  margin: 0; }
    h1 {
      color: #fff;
      font-weight: 400;
      font-size: 1.7em;
      line-height: 1.4em;
    }
    h2 { font-size: 1.2em; }
    h2, h3, h4 {
      color: #fff;
      font-weight: 300;
    }
    .container {
      max-width: 1200px;
      margin: 0 auto;
    }
    .block-social-share {
      z-index: 1;
      margin: 40px 0;
      img { padding-left: 5px; }
      a { z-index: 1; }
    }
    .thankyou-banner {
      position: relative;
      margin-top: -2.5em;
      text-align: center;
    }
    .thankyou-remark {
      position: relative;
      max-width: 550px;
      background: #F68C16;
      font-size: 0.9em;
      padding: 10px;
      margin: 1em auto;
      border-radius:  5px;
    }
    @media all and (max-width: 767px) {
      h1 { font-size: 1.3em; padding: 10px 5px 0;}
      h2 { font-size: 1.1em; }
      p { padding: 0 10px; }
      .block-image-share {
        margin: 10px 0;
        padding: 10px 10px 5px;
        text-align: center;
        background-size: cover;
      }
      .thankyou-remark {
        font-size: 0.85em;
      }
      .thankyou-banner {
        margin: 0;
      }
    }
    @media all and (max-width: 500px) {
      &:before {
        background: none;
      }
      .thankyou-remark {
        font-size: 0.85em;
        max-width: 400px;
      }
    }
    @media all and (max-width: 400px) {
      .block-social-share {
        margin: 20px 0;
        font-size: 0.85em;
        line-height: 1.1em;
      }
    }
  }

  .show-uploadslip .header-wrapper {
    padding: 0;
    background: #fff;
  }

  .block-social-share >>> .button-social {
    margin: 0 5px;
    padding: 5px 7px;
    font-size: 14px;
    line-height: 1.2;
  }

//show note
.show-note {
  background: #fff url("../../../assets/img/bg-line01.png") no-repeat top center;
  background-size: 100%;
  padding: 50px 0;
  @media all and (max-width: 768px) {
    padding: 20px 0;
  }
  .block {
    max-width: 800px;
    margin: 0 auto;
  }
  .form__item {
    margin: 0 auto;
    max-width: 600px;
  }
  .show-note-item {
    margin-bottom: 1.5em;
    &:last-child { margin: 0;}
  }
  .mw-600 {
   max-width: 600px;
   margin: 1em auto;
 }
 .indent {
   padding-left: 18px;
   padding-top: 5px;
 }
}

.promo-link-item-type-link {
  margin: 1rem 0;
}
.promo-link-item-type-linked-image {
  position: relative;
  max-width: 700px;
  margin: auto;
  @media all and (max-width: 768px) {
    max-width: 400px;
  }
}

</style>



// WEBPACK FOOTER //
// base.vue?711931fb